import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createDocumentTemplate, deleteDocumentTemplate, updateDocumentTemplate } from '../services/documentTemplates';
import type { CreateTemplateInput, TemplateMetadataInput } from '../types/documentTemplates.types';
import { documentTemplateKeys } from './documentTemplateKeys';

export const useCreateTemplateMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateTemplateInput) => createDocumentTemplate(input),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: documentTemplateKeys.lists() }),
  });
};

export const useUpdateTemplateMutation = (templateId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: TemplateMetadataInput) => updateDocumentTemplate(templateId, input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: documentTemplateKeys.detail(templateId) });
      queryClient.invalidateQueries({ queryKey: documentTemplateKeys.lists() });
    },
  });
};

export const useDeleteTemplateMutation = (templateId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => deleteDocumentTemplate(templateId),
    onSuccess: () => {
      queryClient.removeQueries({ queryKey: documentTemplateKeys.detail(templateId) });
      queryClient.invalidateQueries({ queryKey: documentTemplateKeys.lists() });
    },
  });
};
